import { useState } from 'react';
import { DateInputProps } from '@oms/ui-date-input';
import { TextInputProps } from '@oms/ui-text-input';
import { isAfter, isWeekend, subMonths, subDays } from 'date-fns';

const useForm = ({ numberOfShares: n = 100, fromDate: f = new Date() }) => {
  const [numberOfShares, setShares] = useState(n);
  const [fromDate, setDate] = useState(f);
  const onChangeShares: TextInputProps['onChange'] = e =>
    void setShares(Number(e.target?.value));
  const onChangeDate: DateInputProps['onChange'] = d => void setDate(d as Date);
  return {
    numberOfShares,
    fromDate,
    onChangeShares,
    onChangeDate,
  };
};

const getInitialDate = (notingdate: string | number | Date | undefined) => {
  if (notingdate) {
    const date = new Date(notingdate);
    if (isAfter(date, subMonths(new Date(), 6))) {
      return date;
    } else {
      const sixMonthsAgo = subMonths(new Date(), 6);
      return isWeekend(sixMonthsAgo) ? subDays(sixMonthsAgo, 2) : sixMonthsAgo;
    }
  } else {
    const date = new Date();
    return isWeekend(subDays(date, 1)) ? subDays(date, 2) : subDays(date, 1);
  }
};

const getDateFormatString = (lang: string = 'en') => {
  const formats: Record<string, string> = {
    en: `DD-MM-YYYY`,
    no: 'DD.MM.YYYY',
  };
  return formats[lang] || formats.en;
};

export { useForm, getInitialDate, getDateFormatString };
